import { mapValues, toString, toNumber } from 'lodash';

const keys = [
    'provider_id',
    'location_id',
    'insurance_carrier_id',
    'insurance_plan_id',
    'visit_reason',
    'procedure_id',
    'specialty_id',
    'plan_id',
];

const transformIds = transformFn =>
    function performTransformIds(body) {
        return mapValues(body, (value, key) => {
            if (keys.includes(key)) {
                return transformFn(value);
            } else {
                return value;
            }
        });
    };

// we need to convert ids that come from the API's responses to strings
export const stringifyIdsFromBody = transformIds(toString);

// we are also converting the ids to numbers before PUTs and POSTs so they don't break any API
export const destringifyIdsForBody = transformIds(toNumber);
